var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"button copy",attrs:{"role":"button"}},[_c('span',{staticClass:"tip"},[_vm._v("別のノートに複製")]),_c('IcCopy',{staticClass:"icn"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }